import React from "react";
import { BsArrowUpSquare } from "react-icons/bs";
import { TbLocation } from "react-icons/tb";
import { FiMail } from "react-icons/fi";
import { BsTelephone } from "react-icons/bs";
import { Link } from "react-scroll";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <>
      <section className="hero is-small">
        <div className="hero-body">
          <div className="columns is-mobile is-centered mt-6 footerContent ">
            <div className="column has-text-centered">
              <BsTelephone className="block" size={40} />
              <div className="content ">
                <h3 className="block is-3 footerContent">
                  {t("contact.phone")}
                </h3>
                <p className="is-size-6-mobile footerContent has-text-weight-bold">
                  <a className="footerContent" href="tel:+21653830825">
                    +216 53 830 825
                  </a>
                </p>
              </div>
            </div>
            <div className="column has-text-centered footerContent">
              <FiMail className="block" size={40} />
              <div className="content">
                <h3 className="block is-3 footerContent">Email</h3>
                <p className=" is-size-6-mobile footerContent has-text-weight-bold">
                  <a
                    className="footerContent"
                    href="mailto:khefifi.montasssar@gmail.com"
                  >
                    {" "}
                    khefifi.montassar@gmail.com
                  </a>
                </p>
              </div>
            </div>
            <div className="column has-text-centered footerContent is-hidden-mobile">
              <TbLocation className="block" size={40} />
              <div className="content">
                <h3 className="block is-3 footerContent">
                  {t("contact.location")}
                </h3>
                <p className=" is-6 footerContent has-text-weight-bold">
                  <a
                    className="footerContent"
                    href="https://goo.gl/maps/Yfa7sm81y5UxJbqu6"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    Nabeul, {t("contact.tun")}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer className="footer footerC">
        <div className="columns">
          <div className="column is-10 is-centered is-offset-1">
            <div className="content is-size-7-mobile has-text-centered  ">
              <p style={{ lineHeight: "5rem" }}>
                COPYRIGHTS &#9400; {new Date().getFullYear()} MONTASSAR KHEFIFI
                - {t("footer.droit")} <br />
                {t("footer.developed")} Montassar Khefifi
              </p>
            </div>
          </div>
          <div className="column">
            <Link activeClass="active" smooth spy to="home">
              <i className="buttons is-right mt-2">
                <BsArrowUpSquare size={45} color={"hsl(171, 100%, 41%)"} />
              </i>
            </Link>
          </div>
        </div>
      </footer>
    </>
  );
}
